import { gql } from '@apollo/client';


export const GET_PERMISSIONS = gql`
    query GetPermissions(
        $text: String
        $first: Int
        $page: Int
        $where: QueryPermissionsWhereWhereConditions
        $whereRoles: QueryPermissionsWhereRolesWhereHasConditions
        $orderBy: [QueryPermissionsOrderByOrderByClause!]
        $lang: String
    ) {
        permissions(
            text: $text
            first: $first
            page: $page
            where: $where
            whereRoles: $whereRoles
            orderBy: $orderBy
        ) {
            paginatorInfo {
                count
                currentPage
                firstItem
                hasMorePages
                lastItem
                lastPage
                perPage
                total
            }
            data {
                id
                slug
                entry_point
                group_name
                action
                translation(lang: $lang) {
                    id
                    group_name
                    lang
                    slug
                    value
                    editable
                    img_path
                    order
                    created_at
                    updated_at
                }
                created_at
                updated_at
            }
        }
    }
`;

export const GET_PERMISSION = gql`
    query GetPermission($id: ID) {
        permission(id: $id) {
            id
            slug
            entry_point
            group_name
            action
            translation(lang: "en") {
                id
                group_name
                lang
                slug
                value
                editable
                img_path
                order
                created_at
                updated_at
                translation(lang: "en") {
                    id
                    group_name
                    lang
                    slug
                    value
                    editable
                    img_path
                    order
                    created_at
                    updated_at
                }
            }
            created_at
            updated_at
        }
    }
`;